/**
 * @typedef {object} QuickFiltersDealInfo
 * @property {string} dealType - sale/rent
 * @property {boolean} isShortTerm
 * @property {string} category - flat/suburban/commercial
 * @property {string[]} objectNames - массив названий выбранных объектов (например, ["flatShare"])
 * @property {Region[]} currentRegions - выбранные регионы
 * @property {boolean} isNewBuilding
 */

import _ from 'lodash';

export default angular.module('cian.newbuild.filter.quickFilters', [])
  .factory('QuickFilters', [
    'RegionUtilsService',
    (RegionUtilsService) => {
      const quickFilters = {
        common: [
          'for_day',
          'price',
        ],
        flat: {
          common: [
            'room',
            'wp',
          ],
          sale: [
            // https://jira.cian.tech/browse/CSSSR-7771
            // building_status - это параметр, который отличает тип объекта "Квартира" от
            // типов "Квартира во вторичке" и "Квартира в новостройке".
            // Если его убрать отсюда, то при очистке тегов "Квартира во вторичке" и "Квартира в новостройке"
            // будут сбрасываться на тип "Квартира".
            // В целом, его можно рассматривать как скрытый быстрый фильтр.
            'building_status',
            'price_sm',
          ],
        },
        suburban: {
          common: [
            'object_type',
            'wp',
          ],
          rentShort: [
            'bedroom_total',
          ],
        },
        commercial: {
          common: [
            'office_type',
            'currency',
            'price_sm',
            'total_area',
          ],
        }
      };

      const conditionalControls = {
        /** @param {QuickFiltersDealInfo} dealInfo */
        'from_mcad_km': dealInfo =>
          dealInfo.category === 'suburban' &&
          RegionUtilsService.isMO(dealInfo.currentRegions),
        /** @param {QuickFiltersDealInfo} dealInfo */
        'total_area': dealInfo =>
          dealInfo.category === 'suburban' &&
          !_.includes(dealInfo.objectNames, 'land') &&
          !conditionalControls['from_mcad_km'](dealInfo)
        ,
        /** @param {QuickFiltersDealInfo} dealInfo */
        'site': dealInfo =>
          _.includes(dealInfo.objectNames, 'land') &&
          !conditionalControls['from_mcad_km'](dealInfo)
        ,
        'is_by_homeowner': dealInfo =>
          (dealInfo.category === 'suburban' || dealInfo.category === 'flat') &&
          !dealInfo.isNewBuilding &&
          // Фильтр "от собственника" не доступен в Москве, МО, СПБ, ЛО и в городах этих областей
          !RegionUtilsService.isMoscowMOSpbLOOrAnyChildCityInTheseRegions(dealInfo.currentRegions)
      };

      return {
        /**
         * @param {QuickFiltersDealInfo} dealInfo
         * @return {string[]} список имён фильтров (например, ['for_day', 'wp'])
         */
        getControlsList: dealInfo => {
          const dealKey = dealInfo.dealType === 'sale' ? 'sale' :
            dealInfo.isShortTerm ? 'rentShort' : 'rentLong';
          const categoryControls = _.get(quickFilters, dealInfo.category) || {};

          const visibleConditionalControls = _.filter(_.keys(conditionalControls),
            key => conditionalControls[key](dealInfo)
          );

          return _.union(
            quickFilters.common,
            categoryControls.common,
            categoryControls[dealKey],
            visibleConditionalControls,
          );
        }
      };
    }])
  .name;



// WEBPACK FOOTER //
// ./src/serp/services/quick-filters.service.js